<template>
  <v-footer white>
    <v-container fluid
                 white>
      <v-layout row
                wrap
                pt-3
                justify-center
                white>

        <change-language-dropdown></change-language-dropdown>

        <v-btn color="grey lighten-1"
               flat
               href="https://developers.wesmartpark.com"
               target="_blank">
          developers
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://parkingmanagers.com"
               target="_blank">
          parkingManagers
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://www.linkedin.com/company/parkingmanagers-by-wesmartpark-"
               target="_blank">
          linkedIn
        </v-btn>

        <v-btn color="grey lighten-1"
               flat
               href="https://plus.google.com/113173029966147173561"
               target="_blank">
          google+
        </v-btn>

        <v-bottom-sheet v-model="sheetContact"
                        class="bg-white">
          <v-btn color="grey lighten-1"
                 flat
                 slot="activator"
                 target="_blank">
            Contacto
          </v-btn>

          <v-container grid-list-md
                       white>
            <v-layout row
                      wrap
                      justify-center
                      class="address-list">
              <template v-for="(item, index) in headquarters">
                <v-flex xs12
                        sm4
                        :key="index"
                        :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
                  <v-list two-line
                          dense>
                    <v-subheader :key="item.city">{{ item.city }}</v-subheader>
                    <v-list-tile :href="`${item.addressLink}`"
                                 target="_blank"
                                 class="address-list-dense"
                                 @click="trackEvent(`'contacto_${item.city}_phone'`)">
                      <v-list-tile-action>
                        <v-icon>location_on</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.address1 }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.address2 }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile :href="`mailto:${item.email}`"
                                 class="address-list-dense"
                                 @click="trackEvent(`'contacto_${item.city}_email'`)">
                      <v-list-tile-action>
                        <v-icon>mail</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.email }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile :href="`tel:${item.phoneLink}`"
                                 class="address-list-dense"
                                 @click="trackEvent(`'contacto_${item.city}_phone'`)">
                      <v-list-tile-action>
                        <v-icon>phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.phone }}</v-list-tile-title>
                        <v-list-tile-sub-title> {{ item.phoneDescription }} </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </template>
            </v-layout>

          </v-container>
        </v-bottom-sheet>

        <v-flex xs12
                pb-3
                pt-1
                text-xs-center>
          <img src="/static/img/emprendetur.jpg"
               alt="Emprendetur"
               height="60px" />
          <img src="/static/img/enisa.jpg"
               alt="Enisa"
               height="60px" />
        </v-flex>

        <v-flex xs12
                pb-3
                pt-1
                text-xs-center
                grey--text>
          &copy;{{year}} — wesmartPark
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
import store from '@/store';
import ChangeLanguageDropdown from '@/components/ChangeLanguageDropdown';

export default {
  name: 'wsp-footer',
  components: {
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown
  },
  data() {
    return {
      headquarters: store.state.headquarters,
      year: new Date().getFullYear(),
      sheetContact: false
    };
  },
  updated() {},
  mounted() {},
  created() {},
  destroyed() {},
  methods: {}
};
</script>

<style lang="scss">
.address-list .list__tile__content {
  font-size: 11px;
}

.address-list .list--dense .list__tile__sub-title {
  font-size: 10px;
}

.address-list .list__tile__action {
  min-width: 30px;
}

.address-list .list__tile__title {
  height: 20px;
  line-height: 21px;
}

.address-list .address-list-dense {
  height: 45px;
}

.address-list .subheader {
  height: 10px;
}

.address-list .v-card__media__content img {
  width: 50px;
  margin: 0 auto;
}

.bg-white .v-bottom-sheet {
  background-color: white !important;
}

footer {
  height: auto !important;
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WspFooter.vue